import api from './api';

class OrderService {
    async createOrder(data) {
        return api.post('orders/create_order/', data);
    }

    async getOrders() {
        return api.get('orders/');
    }

    async getOrder(id) {
        return api.get(`orders/${id}/`);
    }

    async processPayment(orderId) {
        // Mock payment processing or integration initiation
        return api.post(`payments/process/${orderId}/`); // Adjust endpoint as needed
    }
}

export default new OrderService();
